import { BasePageProps, BasePageState, basePageInitialState } from '../BasePage'

import { store } from '../../redux/store'

import { createReducer, createAction } from '@reduxjs/toolkit'

export interface BicyclePageProps extends BasePageProps {}

type BicycleState = {
    tipo_veicolo: string | undefined
    tipo_parcheggio: string | undefined
    tipo_utilizzo: string | undefined
    gare: boolean | undefined
    fascia_prezzo: string | undefined

    tipo_veicoloError: string | undefined
    tipo_parcheggioError: string | undefined
    tipo_utilizzoError: string | undefined
    gareError: string | undefined
    fascia_prezzoError: string | undefined

    tipoBicicletta: any
    tipoParcheggioBici: any
    tipoUtilizzoBici: any
    fasciaPrezzoBici: any
}

export type BicyclePageState = BicycleState & BasePageState

export const bicycleInitialState : BicyclePageState = {
    ...basePageInitialState,
    ...{
        tipo_veicolo: undefined,
        tipo_parcheggio: undefined,
        tipo_utilizzo: undefined,
        gare: undefined,
        fascia_prezzo: undefined,

        tipo_veicoloError: undefined,
        tipo_parcheggioError: undefined,
        tipo_utilizzoError: undefined,
        gareError: undefined,
        fascia_prezzoError: undefined,

        tipoBicicletta: undefined,
        tipoParcheggioBici: undefined,
        tipoUtilizzoBici: undefined,
        fasciaPrezzoBici: undefined,
    }
}

export const bicycleUpdate = createAction<BicyclePageState>('bicycle/update')

export const bicycleReducer = createReducer ( 
    bicycleInitialState,
    (builder) => {
        builder.addCase(bicycleUpdate, (state, action) => {
            return action.payload as BicyclePageState
        })
    }
)

export type BicycleRootState = ReturnType<typeof store.getState>
export type BicycleDispatch = typeof store.dispatch